import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
// 🚀 INYECTADO: Desbloquea la directiva [(ngModel)] en este componente Standalone
import { FormsModule } from '@angular/forms'; 

import { Unidades } from '../../Unidades/models/unidades'; 
import { UnidadesService } from '../../Service/unidades-service';
import { UnidadEdit } from '../unidad-edit/unidad-edit';
import { ToastService } from '../../Service/toast-service'; 
import { Router } from '@angular/router';

@Component({
  selector: 'app-unidad-list',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLinkActive, RouterLink, FormsModule],
  templateUrl: './unidad-list.html',
  styleUrl: './unidad-list.css',
})
export class UnidadList implements OnInit {

  unidades: Unidades[] = [];

  filtroUnidad: string = '';
  unidadesFiltradas: any[] = []; // Usar esta variable en tu *ngFor

  // =========================================================================
  // 🎛️ VARIABLES CORE PARA TU NUEVA PAGINACIÓN REACTIVA DE VEHÍCULOS
  // =========================================================================
  paginaActual: number = 1;
  registrosPorPagina: number = 10; // Límite exacto de renglones por rejilla
  totalPaginas: number = 1;

  // Hacemos visible la librería Math para que la plantilla HTML no arroje errores ts(2339)
  protected readonly Math = Math;  

  constructor(
    private unidadesService: UnidadesService,
    public dialog: MatDialog,
    public toastService: ToastService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ){

  }

  ngOnInit(): void {
    // =========================================================================
    // 🛡️ RECEPTOR DE ESTADOS ASÍNCRONOS MULTI-TENANT (CICLO SEGURO)
    // SOLUCIÓN: Usamos history.state para rescatar el mensaje del alta.
    // Al ejecutarlo aquí, el componente ya nació de forma legal y sanamos 
    // el error de 'ASSERTION ERROR' al 100% libre de parpadeos.
    // =========================================================================
    const estadoRuta = typeof window !== 'undefined' ? history.state : null;

    if (estadoRuta && estadoRuta['mostrarAlertaExito']) {
      // Disparamos tu Toast flotante verde corporativo sobre el grid
      this.toastService.showSuccess('Registro Exitoso', estadoRuta['mensajeToast']);
      
      // Forzamos a Angular a redibujar el contenedor de Toasts de forma legal
      this.cdr.detectChanges();
    }

    // 🚀 TU LLAMADA TRADICIONAL HISTÓRICA INTACTA
    this.listUnidades();
  }

  listUnidades(): void {
    this.unidadesService.getUnidadesList().subscribe({
      next: (data) => {
        this.unidades = data;
        
        // 💡 SOLUCIÓN OPERATIVA: Clona los datos aquí para que el grid nazca lleno 
        // en cuanto el asesor entra a la pantalla de unidades.
        this.unidadesFiltradas = [...data];
        
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al recuperar listado de unidades:', err)
    });
  }

  deleteUnidad(id: number): void {
    if (confirm('¿Está seguro de eliminar de forma permanente este vehículo del taller?')) {
      console.log('Despachando solicitud de borrado para Unidad ID:', id);
      this.unidadesService.deleteUnidadById(id).subscribe({
        next: () => this.listUnidades(),
        error: (err) => console.error('No se pudo eliminar la unidad vehicular:', err)
      });
    }
  }

  editUnidad(unidad: Unidades): void {
    const dialogRef = this.dialog.open(UnidadEdit, {
      data: unidad, // Pasa el vehículo completo al modal de edición
      width: '950px', 
      maxWidth: '95vw',
      height: 'auto', // Ajustado a auto para que sea responsivo en pantalla
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container' 
    });

    dialogRef.afterClosed().subscribe(result => {

      console.log(">>> MODAL CERRADO. Payload recibido en el listado:", result); // 🌟 AGREGA ESTE LOG

      if (result && result.id) {

        console.log(">>> CONDICIÓN CUMPLIDA. Ejecutando Toast..."); // 🌟 AGREGA ESTE LOG
        // ... tu lógica de indexación ...
        
        // Localización del índice en memoria para actualización reactiva en caliente
        const index = this.unidades.findIndex(u => u.id === result.id);
        if (index !== -1) {
          this.unidades[index] = result;
        }

        // CORREGIDO: Navegación relacional hacia la propiedad customer.an8 de tu interfaz
/*         console.log("ID de unidad indexada y actualizada:", this.unidades[index].id);
        if (this.unidades[index].propietario) {
          console.log("AN8 del dueño corporativo asociado:", this.unidades[index].propietario.an8);
        }
        
        console.log("Resultado del payload modificado:", result.id, result.marca, result.submarca); */

        // 2. 🌟 SOLUCIÓN CORE: Disparamos el Toast flotante desde la lista activa
        this.toastService.showSuccess(
          'Cambios Guardados', 
          `La ficha técnica del vehículo con placas [${result.placas.toUpperCase()}] se actualizó con éxito.`
        );

        // Actualizar el registro en la lista tras el cierre seguro del diálogo
        this.listUnidades();

        // 🌟 FORZAR ACTUALIZACIÓN VISUAL: Obliga a Bootstrap y al HTML a pintar el Toast en este microsegundo
        this.cdr.markForCheck();
        this.cdr.detectChanges();

      } else {
        console.warn(">>> ALERTA: La condición falló. El 'result' vino nulo o sin 'id'."); // 🌟 AGREGA ESTE LOG
      }
    });
  }

  filtrarUnidades(): void {
    const busqueda = this.filtroUnidad.trim().toUpperCase();
    
    if (!busqueda) {
      this.unidadesFiltradas = [...this.unidades];
      return;
    }

    this.unidadesFiltradas = this.unidades.filter((u: Unidades) => {
      // 1. Buscamos en las propiedades técnicas nativas declaradas en tu interfaz
      const cumpleVehiculo = (u.marca && u.marca.toUpperCase().includes(busqueda)) ||
                             (u.submarca && u.submarca.toUpperCase().includes(busqueda)) ||
                             (u.placas && u.placas.toUpperCase().includes(busqueda)) ||
                             (u.modelo && u.modelo.toUpperCase().includes(busqueda)) ||
                             (u.numerovin && u.numerovin.toUpperCase().includes(busqueda));

      // 2. 🚀 INGENIERÍA RELACIONAL DE PRECISIÓN JDE (VÍNCULO CON TU PROPIETARIO):
      // Navegamos de forma segura a través de tu subobjeto 'propietario'
      let cumplePropietario = false;
      if (u.propietario) {
        // Extraemos de forma segura el AN8 de 8 dígitos de la f0101
        const propietarioAn8Str = u.propietario.an8 ? u.propietario.an8.toString() : '';
        
        // Soportamos que la variable del nombre venga mapeada como 'name', 'alph' o 'razonSocial' según tu DTO
        const propObj = u.propietario as any;
        const propietarioNombre = propObj.alph || propObj.name || propObj.razonSocial || '';

        cumplePropietario = propietarioAn8Str.includes(busqueda) ||
                            (propietarioNombre && propietarioNombre.toUpperCase().includes(busqueda));
      }

      // Si coincide la información del auto O el identificador del dueño, el renglón se queda
      return cumpleVehiculo || cumplePropietario;
    });
    
    this.paginaActual = 1;
    this.calcularTotalPaginas();

    this.cdr.detectChanges();
  }
  
  
  // 🚀 ADUANA NGTSC: Sincroniza el rastreador de índices dinámicos en el grid de autos
  trackById(index: number, unidad: Unidades): number {
    return unidad.id || index;
  }
  
  calcularTotalPaginas(): void {
    // Evitamos divisiones por cero si el filtro de búsqueda no arroja autos
    this.totalPaginas = Math.ceil(this.unidadesFiltradas.length / this.registrosPorPagina) || 1; // Ajusta 'unidadesFiltradas' al nombre de tu array de filtros
    this.cdr.detectChanges();
  }

  cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      console.log('>>> [PREFS JDE] Conmutando rampa de autos a la página:', this.paginaActual);
      this.cdr.detectChanges();
    }
  }

  /**
   * 💡 LA COMPUERTA RECTANGULAR RECTACTIVA:
   * Recorta el array de vehículos filtrados para la vista HTML.
   */
  get unidadesPaginadas(): any[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.unidadesFiltradas.slice(inicio, fin); // Ajusta 'unidadesFiltradas' al nombre de tu array de filtros
  }

}